<script lang="ts">
  // A breakthrough medal: ribbon, rimmed disc and star, coloured by level.
  import { MEDAL_COLORS } from '../context'
  import type { MedalLevel } from '../types'

  export let level: MedalLevel
  export let size = 200
  export let glow = true

  const uid = Math.random().toString(36).slice(2, 8)
  $: c = MEDAL_COLORS[level] ?? MEDAL_COLORS.gold
</script>

<svg width={size} height={size * 1.25} viewBox="0 0 200 250" aria-hidden="true" class="xr-medal">
  <defs>
    <linearGradient id="disc-{uid}" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color={c.light} />
      <stop offset="0.55" stop-color={c.main} />
      <stop offset="1" stop-color={c.dark} />
    </linearGradient>
    <linearGradient id="rim-{uid}" x1="1" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color={c.light} />
      <stop offset="1" stop-color={c.dark} />
    </linearGradient>
    <radialGradient id="glow-{uid}">
      <stop offset="0" stop-color={c.main} stop-opacity="0.55" />
      <stop offset="1" stop-color={c.main} stop-opacity="0" />
    </radialGradient>
  </defs>
  {#if glow}
    <circle cx="100" cy="160" r="100" fill="url(#glow-{uid})" />
  {/if}
  <!-- ribbon -->
  <path d="M62 0 h34 l22 92 h-34 z" fill="var(--accent, #3cc7c4)" opacity="0.95" />
  <path d="M138 0 h-34 l-22 92 h34 z" fill="var(--accent, #3cc7c4)" opacity="0.7" />
  <path d="M62 0 h34 l22 92 h-34 z" fill="black" opacity="0.15" />
  <!-- disc -->
  <circle cx="100" cy="160" r="68" fill="url(#rim-{uid})" />
  <circle cx="100" cy="160" r="58" fill="url(#disc-{uid})" />
  <circle cx="100" cy="160" r="58" fill="none" stroke={c.dark} stroke-opacity="0.35" stroke-width="2" />
  <path
    d="M100 124 l10.6 21.5 23.7 3.4 -17.2 16.7 4.1 23.6 -21.2 -11.2 -21.2 11.2 4.1 -23.6 -17.2 -16.7 23.7 -3.4 z"
    fill={c.light}
    stroke={c.dark}
    stroke-opacity="0.5"
    stroke-width="2"
    stroke-linejoin="round"
  />
  <ellipse cx="80" cy="132" rx="22" ry="9" fill="white" opacity="0.25" transform="rotate(-30 80 132)" />
</svg>

<style>
  .xr-medal {
    display: block;
    overflow: visible;
  }
</style>
